import { useMemo, useState } from 'react';
import {
    useReactTable,
    getCoreRowModel,
    getPaginationRowModel,
    getFilteredRowModel,
    flexRender,
} from '@tanstack/react-table';
import { __ } from '@wordpress/i18n';

export default function LoginAttemptTable({ data }) {
    const [globalFilter, setGlobalFilter] = useState('');
    const columns = useMemo(() => [
        { header: 'IP Address', accessorKey: 'ip_address', cell: ({ row }) => (
      <div>
        <div className='login-ip'>{row.original.ip_address}</div>
        <div className='date-time'>{row.original.cur_time}</div>
      </div>
    ), },
        { header: 'Username', accessorKey: 'username' },
        { header: 'Attempt', accessorKey: 'attempt' },
        { header: 'Lockouts', accessorKey: 'lockouts' },
    ], []);

  const table = useReactTable({
    data,
    columns,
    state: { globalFilter },
    onGlobalFilterChange: setGlobalFilter,
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    globalFilterFn: 'includesString', // default filter
    initialState: {
      pagination: { pageSize: 5, pageIndex: 0 },
    },
  });

  const { pageIndex, pageCount } = table.getState().pagination;

  const visiblePages = () => {
    const pages = [];
    for (let i = 0; i < pageCount; i++) {
      if (i === 0 || i === pageCount - 1 || Math.abs(i - pageIndex) <= 1) {
        pages.push(i);
      } else if (pages[pages.length - 1] !== '...') {
        pages.push('...');
      }
    }
    return pages;
  };

  return (
    <>
        <div className='nxt-login-table-filter'>
            <div className="nxtext_secondary_heading">{__('View Logs','nexter-extension')}</div>
            <input
                value={globalFilter ?? ''}
                onChange={(e) => setGlobalFilter(e.target.value)}
                placeholder="Search"
                style={{ marginBottom: '10px', padding: '6px', width: '100%' }}
            />
        </div>
        <table className="nxt-login-table-wrap">
        <thead>
          {table.getHeaderGroups().map(headerGroup => (
            <tr key={headerGroup.id}>
              {headerGroup.headers.map(header => (
                <th key={header.id}>
                  {flexRender(header.column.columnDef.header, header.getContext())}
                </th>
              ))}
            </tr>
          ))}
        </thead>

        <tbody>
          {table.getRowModel().rows.map(row => (
            <tr key={row.id}>
              {row.getVisibleCells().map(cell => (
                <td key={cell.id}>
                  {flexRender(cell.column.columnDef.cell, cell.getContext())}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
        </table>
        <div className='nxt-login-list-pagination'>
            <div className='nxt-login-show-list'>
                <div className='nxt-show-list-prefix'>{__('Show lists to','nexter-extension')}</div>
                <select
                    value={table.getState().pagination.pageSize}
                    onChange={(e) => {
                        table.setPageSize(Number(e.target.value));
                    }}
                >
                {[5, 10, 20].map(pageSize => (
                    <option key={pageSize} value={pageSize}>
                    {pageSize}
                    </option>
                ))}
                </select>
            </div>
            <div className='nxt-login-pagination'>
                <button onClick={() => table.previousPage()} disabled={!table.getCanPreviousPage()}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" fill="none" viewBox="0 0 6 10"><path stroke={!table.getCanPreviousPage() ? "#888" : "#1A1A1A"} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.333" d="m5 9.294-4-4 4-4"/></svg> {__('Previous','nexter-extension')}
                </button>

                {visiblePages().map((page, i) => (
                    <button
                    key={i}
                    onClick={() => typeof page === 'number' && table.setPageIndex(page)}
                    disabled={page === '...'}
                    style={{
                        padding: '6px 12px',
                        borderRadius: '6px',
                        background: page === pageIndex ? '#F0F0F1' : 'transparent',
                        fontWeight: page === pageIndex ? 'bold' : 'normal',
                        cursor: page === '...' ? 'default' : 'pointer',
                        border: page === pageIndex ? "1px solid #D1D1D6" : 'none',
                        color: '#F0F0F1',
                    }}
                    >
                    {typeof page === 'number' ? page + 1 : '...'}
                    </button>
                ))}

                <button onClick={() => table.nextPage()} disabled={!table.getCanNextPage()}>
                    {__('Next','nexter-extension')} <svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" fill="none" viewBox="0 0 6 10"><path stroke={!table.getCanNextPage() ? "#888" : "#1A1A1A"} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.333" d="m1 9.294 4-4-4-4"/></svg>
                </button>
            </div>
        </div>
    </>
  );
}
